<template>
  <main>
    <ContactSection />
  </main>
</template>

<script>
import ContactSection from '../components/ContactSection.vue'

export default {
  name: 'ContactPage',
  components: {
    ContactSection
  }
}
</script>
